import React from "react";
import "./App.css";
import Homepage from "./Pages/Homepage";
import ChatPage from "./Pages/ChatPage";
import Navigation from "./components/miscellaneous/Navigation";
import { Routes, Route, useLocation } from "react-router-dom";
import Landing from "./Pages/Landing";
import Footer from "./components/miscellaneous/Footer";
import CategoryPage from "./Pages/CategoryPage";
import VendorProfilePage from "./Pages/VendorProfilePage";
import UserProfilePage from "./Pages/UserProfilePage";
import OurPromisePage from "./Pages/OurPromisePage";
import TricksOfTheTradePage from "./Pages/TricksOfTheTradePage";
import QuickFixesPage from "./Pages/QuickFixesPage ";
import FixLeakyFaucetPage from "./Pages/quick-fix-pages/FixLeakyFaucetPage";
import UncloggingSinkPage from "./Pages/quick-fix-pages/UncloggingSinkPage";
import PatchDrywallPage from "./Pages/quick-fix-pages/PatchDrywallPage";
import ResetBreakerPage from "./Pages/quick-fix-pages/ResetBreakerPage ";
import ToolMaintenancePage from "./Pages/ToolMaintenancePage";
import PaintingHacksPage from "./Pages/PaintingHacksPage ";
import LightingElectricalTipsPage from "./Pages/LightingElectricalTipsPage ";
import SupportPage from "./Pages/SupportPage";
import VendorPendingApproval from "./Pages/VendorPendingApproval";
import VendorRejected from "./Pages/VendorRejected";
import CustomerBanned from "./Pages/CustomerBanned";
import NotFoundPage from "./Pages/NotFoundPage";
import AdminDashboard from "./admin/AdminDashboard";
import VendorJobsPage from "./Pages/VendorJobsPage";
import VendorDashboard from "./Pages/VendorDashboard";
import DisclaimerPage from "./Pages/DisclaimerPage";
import ContactUsPage from "./Pages/ContactUsPage";
import ResetPasswordPage from "./Pages/ResetPasswordPage";
import EmailVerificationPage from "./Pages/EmailVerificationPage";

function App() {
  const location = useLocation();

  // Condition to hide Navigation on "/" and "/login" paths
  const hideNavigation = location.pathname === "/login";

  return (
    <div className="App">
      {!hideNavigation && <Navigation />}{" "}
      {/* Conditionally render Navigation */}
      <div className="main-content">
        {" "}
        {/* Main content wrapper */}
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Homepage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/verify-email" element={<EmailVerificationPage />} />
          <Route path="/vendor-pending" element={<VendorPendingApproval />} />
          <Route path="/vendor-rejected" element={<VendorRejected />} />
          <Route path="/customer-banned" element={<CustomerBanned />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/vendor-dashboard" element={<VendorDashboard />} />
          <Route path="/vendor-jobs" element={<VendorJobsPage />} />
          <Route path="/chats" element={<ChatPage />} />
          <Route path="/support/contact-us" element={<ContactUsPage />} />
          <Route path="/category/:category" element={<CategoryPage />} />
          <Route path="/vendor/:vendorId" element={<VendorProfilePage />} />
          <Route path="/profile" element={<UserProfilePage />} />
          <Route path="/our-promise" element={<OurPromisePage />} />
          <Route path="/support" element={<SupportPage />} />
          <Route
            path="/tricks-of-the-trade"
            element={<TricksOfTheTradePage />}
          />

          {/* Tool Maintenance Page */}
          <Route path="/tool-maintenance" element={<ToolMaintenancePage />} />

          {/* Quick Fix Pages */}
          <Route path="/quick-fix" element={<QuickFixesPage />} />
          <Route
            path="/quick-fix/leaky-faucet"
            element={<FixLeakyFaucetPage />}
          />
          <Route
            path="/quick-fix/unclog-sink"
            element={<UncloggingSinkPage />}
          />
          <Route
            path="/quick-fix/patch-drywall"
            element={<PatchDrywallPage />}
          />
          <Route
            path="/quick-fix/reset-breaker"
            element={<ResetBreakerPage />}
          />

          {/* DIY Painting hack */}
          <Route path="/diy-painting" element={<PaintingHacksPage />} />

          {/* DIY Painting hack */}
          <Route
            path="/electric-tips"
            element={<LightingElectricalTipsPage />}
          />

          {/* Disclaimer Page */}
          <Route path="/disclaimer" element={<DisclaimerPage />} />

          {/* 404 Not Found - Must be last */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>
      <Footer />
    </div>
  );
}

export default App;
